import { PortalThunk, portalAction } from '..'
import { normalizeConsumerTagKey } from '@afterpaytouch/portal-api/consumer/tags'
import { TagsRequest } from '../../model'

const normalizeTagsRequest = (request: TagsRequest): TagsRequest => ({
  ...request,
  name: normalizeConsumerTagKey(request.name),
})

export const postTag: PortalThunk<TagsRequest, void> = portalAction(
  'tags/post',
  async (request, thunk) => await thunk.extra.portalApi().post('/portal/consumers/tags', normalizeTagsRequest(request))
)

export const updateTag: PortalThunk<TagsRequest, void> = portalAction(
  'tags/update',
  async (request, thunk) => await thunk.extra.portalApi().put('/portal/consumers/tags', normalizeTagsRequest(request))
)
